export type PaymentStatus = 'pending' | 'paid' | 'expired' | 'cancelled';

export interface Payment {
  paymentId: string;
  orderNo: string | null;
  amount: string;
  requestedAmount: string;
  currency: string;
  description: string;
  metadata: Record<string, unknown> | null;
  status: PaymentStatus;
  qrCode: string;
  proof: { source: string; reference: string | null } | null;
  note?: string | null;
  expiresAt: string;
  paidAt: string | null;
  cancelledAt: string | null;
  createdAt: string;
}

export interface Total {
  count: number;
  total: string;
}

export interface Overview {
  today: Total;
  week: Total;
  month: Total;
  pending: Total & { payments: Payment[] };
  daily: { day: string; count: number; total: string }[];
  merchantReady: boolean;
}

export interface PaymentList {
  payments: Payment[];
  total: number;
  page: number;
  limit: number;
  summary: { status: string; count: number; total: string }[];
}

export interface WebhookDelivery {
  id: number;
  paymentId?: string;
  event: string;
  url: string;
  status: string;
  attempts: number;
  lastError: string | null;
  nextAttemptAt: string;
  createdAt: string;
}

export interface BankNotification {
  id: number;
  message: string;
  result: string;
  paymentId: string | null;
  createdAt: string;
}

export interface MerchantProfile {
  merchantId: number;
  name: string;
  keyPrefix: string;
  laoQrPayload: string;
  destinationAccount: string;
  accountName: string | null;
  webhookUrl: string | null;
  notifyToken: string | null;
  notifyUrl: string;
  apiUrl: string;
  active: boolean;
  createdAt: string;
}

export const STATUS_LABEL: Record<string, string> = {
  pending: 'ລໍຖ້າຈ່າຍ',
  paid: 'ຈ່າຍແລ້ວ',
  expired: 'ໝົດອາຍຸ',
  cancelled: 'ຍົກເລີກ',
  queued: 'ຢູ່ໃນຄິວ',
  delivered: 'ສົ່ງເຖິງແລ້ວ',
  failed: 'ສົ່ງບໍ່ໄດ້',
};

export const PROOF_LABEL: Record<string, string> = {
  bank_notification: 'ແຈ້ງເຕືອນມືຖື',
  oneproof: 'ສະລິບ OneProof',
  manual: 'ຢືນຢັນເອງ',
};

export const NOTIFY_RESULT_LABEL: Record<string, string> = {
  SUCCESS: 'ຈັບຄູ່ສຳເລັດ',
  NO_MATCHING_PAYMENT: 'ບໍ່ພົບລາຍການທີ່ກົງ',
  AMBIGUOUS_AMOUNT: 'ກົງຫຼາຍລາຍການ',
};
